import Button from '@atoms/Button/Button';
import Image from '@atoms/Image/Image';
import { IPromoCard } from '@models/IPromoCard';
import useMediaQuery from '@utils/hooks/useMediaQuery';
import classNames from 'classnames';

const PromoCard = ({
  title,
  text,
  cta,
  image,
  isLargeCard,
  dataTestId = 'Promo-Card',
  meta,
  epiEdit,
}: IPromoCard) => {
  const isMobile = useMediaQuery(1440);

  return (
    <div
      className={classNames(
        'relative flex h-full w-full flex-col items-center justify-between gap-13 rounded-[10px] bg-grey-600 text-white lg:gap-7.5',
        isLargeCard
          ? 'px-4 pt-4 pb-13 xl:gap-10 xl:pb-10'
          : 'px-4 pt-4 pb-13 lg:px-3 lg:pt-4 lg:pb-4 xl:gap-13 xl:px-4 xl:pb-13'
      )}
      data-testid={dataTestId}
      data-epi-property-name={epiEdit}
    >
      {image && (
        <Image
          image={image}
          classes="w-full"
          imageClasses="w-full object-contain rounded-[10px]"
          dataTestId={`${dataTestId}-Image`}
          epiEdit={meta?.editHints?.image as string}
        />
      )}
      <div
        className={classNames(
          'flex w-[85%] flex-col items-center justify-center',
          isLargeCard ? 'grow gap-4 lg:gap-7.5 xl:gap-6' : 'gap-5'
        )}
      >
        <div
          className={classNames(
            'flex flex-col',
            isLargeCard ? 'gap-4 lg:gap-7.5 xl:gap-6' : 'gap-2.5'
          )}
        >
          <p
            className={classNames(
              'text-center',
              isMobile || !isLargeCard ? 'h5' : 'h3'
            )}
            data-testid={`${dataTestId}-Title`}
            data-epi-property-name={meta?.editHints?.title}
          >
            {title}
          </p>
          {text && (
            <p
              className="body-one text-center"
              data-testid={`${dataTestId}-Text`}
              data-epi-property-name={meta?.editHints?.text}
            >
              {text}
            </p>
          )}
        </div>
        {cta?.url && cta.name && (
          <Button
            className="text-center"
            link={cta}
            dataTestId={`${dataTestId}-Link`}
            editHint={meta?.editHints?.cta as string}
          />
        )}
      </div>
    </div>
  );
};

export default PromoCard;
